export const $Event_SynchronizeBookingsCountToConfirm = '$Event_SynchronizeBookingsCountToConfirm';


export class EventNames {
    public static asyncSidebar = {
        cancel: 'asyncSidebarCancel'
    }

    public static occupancySync = {
        reactivated: 'occupancySyncReactivated'
    }
}
